export default "__VITE_PUBLIC_ASSET__5272f27f__"